import { ConnectComponentsProvider, ConnectPayments } from '@stripe/react-connect-js';
import useStripeConnect from '@hooks/useStripeConnect';
import { Typography } from 'antd';

interface Props {
    connectedAccountId: string;
}

export default function PaymentsTable({ connectedAccountId }: Props) {
    const stripeConnectInstance = useStripeConnect(connectedAccountId);

    if (!connectedAccountId || !stripeConnectInstance) {
        return <Typography>Stipe account loading or not connected successfully</Typography>;
    }

    return (
        <ConnectComponentsProvider connectInstance={stripeConnectInstance}>
            <ConnectPayments
            // Optional: specify filters to apply on load
            // defaultFilters={{
            //   amount: {greaterThan: 100},
            //   date: {before: new Date(2024, 0, 1)},
            //   status: ['partially_refunded', 'refund_pending', 'refunded'],
            //   paymentMethod: 'card',
            // }}
            />
        </ConnectComponentsProvider>
    );
}
